import { getInstanceId } from '@va/dashboard/selectors/app';
import { AiChatbotConversationQuota, getConversationQuota } from '@va/dashboard/shared/ai-assistant';
import { useFetchData } from '@va/util/hooks';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useAiChatbotQuota = () => {
  const websiteId = useSelector(getInstanceId);

  const fetcher = useCallback(() => getConversationQuota(websiteId), [websiteId]);

  return useFetchData<AiChatbotConversationQuota>(
    ['aiChatbotConversationQuota', websiteId],
    undefined,
    undefined,
    fetcher,
  );
};
